import { IconButton, Link, Modal } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";

import { Button, Paragraph, StyledGrid } from "components/simple";
import { color, fontSize, spacingDefaults } from "style/constants";

interface ForceReleaseClaimModalProps {
  show: boolean;
  claimUserName: string;
  onAccept(): void;
  onCancel(): void;
}

const ForceReleaseClaimModal: React.FC<ForceReleaseClaimModalProps> = ({
  show,
  claimUserName,
  onAccept,
  onCancel
}: ForceReleaseClaimModalProps) => {
  return (
    <Modal onClose={onCancel} open={show}>
      <StyledGrid
        alignItems="center"
        backgroundColor={color.WHITE}
        border={`1px solid ${color.MUTEDGRAY}`}
        borderRadius="8px"
        container
        direction="column"
        left="50%"
        padding={`${spacingDefaults.xlarge} ${spacingDefaults.large}`}
        position="absolute"
        top="50%"
        transform="translateX(-50%) translateY(-50%)"
        width="475px"
      >
        <StyledGrid
          item
          position="absolute"
          right={spacingDefaults.xsmall}
          top={spacingDefaults.xsmall}
        >
          <IconButton aria-label="close" key="close" onClick={onCancel}>
            <Close />
          </IconButton>
        </StyledGrid>

        <StyledGrid item textAlign="center">
          <Paragraph color={color.DARKGRAY}>
            These assessments have been locked by another user:
          </Paragraph>

          <Paragraph color={color.DARKGRAY} fontSize={fontSize.large} fontWeight="bold">
            {claimUserName}
          </Paragraph>

          <Paragraph color={color.DARKGRAY}>
            You will be unable to score any assessments, finalize, or submit for review to prevent
            overwriting their work. If necessary, you can forcibly remove this lock below.
          </Paragraph>
        </StyledGrid>

        <StyledGrid item>
          <Button warning onClick={onAccept}>
            Remove Lock
          </Button>
        </StyledGrid>

        <StyledGrid item>
          <Link component="button" onClick={onCancel}>
            <Paragraph color={color.BLACK} textDecoration="underline">
              Cancel
            </Paragraph>
          </Link>
        </StyledGrid>
      </StyledGrid>
    </Modal>
  );
};

export default ForceReleaseClaimModal;
